import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import AddIcon from '@mui/icons-material/Add'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { useCallback } from 'react'

export function AddConceptConfigurationButton() {
  const match = useRouteMatch()
  const history = useHistory()

  const { t } = useTranslation()

  const onClick = useCallback(() => {
    history.push(`${match.url}/new`)
  }, [match.url])

  return (
    <Button variant='contained' onClick={onClick} data-testid='add' startIcon={<AddIcon />} size='small'>
      {t(`global.configure_concept`)}
    </Button>
  )
}
